export default __webpack_public_path__ + "static/media/alert.c206fdb3.svg";